<template>
  <div>
    <p
      class="overh fontw font16 curp"
      @click="detail(data.question.guid)"
      v-html="data.question.questiontitle"
    ></p>
    <p
      class="mt10 c99 overh2"
      v-if="state && type == 'question'"
      v-html="data.question.answercontent || ''"
    ></p>
    <p
      class="mt10 c99 overh2"
      v-if="state && type != 'question'"
      v-html="data.answer.ansewercontent || ''"
    ></p>
    <div v-if="type == 'question'">
      <p
        class="mt10 c99 font13 overh"
        v-for="(item, index) in data.question.userCommentList"
        :key="index"
      >
        {{ item.addusername }}: <span v-html="item.content"></span>
      </p>
    </div>
    <div class="mt15" v-if="data.question.taglist && data.question.taglist.length > 0">
      <el-tag
        class="mr10"
        type="info"
        v-for="(items, indexs) in data.question.taglist"
        :key="indexs"
        >{{ items.tagname }}</el-tag
      >
    </div>
    <item-tool-bar
      :layout="toolLayout"
      :data="data.question"
      type="question"
      share="qustion"
      @share="shareHader"
      @collect="$emit('collect')"
      :rowguid="data.question.guid"
      @shield="$emit('shield')"
    ></item-tool-bar>
  </div>
</template>

<script>
import itemToolBar from "@components/sys/item-tool-bar/index";
export default {
  components: {
    itemToolBar,
  },
  props: {
    data: {
      type: Object,
      default: () => ({
        id: "",
        title: "",
        coverfileguid: "",
      }),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // toolLayout: {
    //     type: String,
    //     default: 'views,collect,share,addtime',
    // },
    action: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    state: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      toolLayout: "views,onlycom,collect,share,addtime",
    };
  },
  methods: {
    detail(guid) {
      if (this.type == "question") {
        this.$store.dispatch("analysis/updateHits", {
          visitlocation: "每日一问-详情",
        });
      }
      this.$get(
        `${this.$store.state.api.webUrl}/question/detail.json`,
        {
          guid,
        },
        (data) => {
          this.$router.push({
            path: "/everydayQuestion/questionInfo?guid=" + guid,
          });
        }
      );
    },
    shareHader(data) {
      this.$emit("share", data);
    },
  },
};
</script>

<style></style>
